(function () {
  if (window.__uwProductInit) return;
  window.__uwProductInit = true;

  function parseVariants(root) {
    var node = root.querySelector('[data-uw-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (err) {
      return [];
    }
  }

  function findVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts.length !== chosen.length) continue;
      var same = true;
      for (var j = 0; j < chosen.length; j++) {
        if (opts[j] !== chosen[j]) { same = false; break; }
      }
      if (same) return variants[i];
    }
    return null;
  }

  function chosenValues(root) {
    var selects = root.querySelectorAll('[data-uw-option-index]');
    var out = [];
    Array.prototype.forEach.call(selects, function (sel) {
      out[parseInt(sel.getAttribute('data-uw-option-index'), 10)] = sel.value;
    });
    return out;
  }

  function setButtonLabel(button, soldOut) {
    if (!button || !button.closest) return;
    var form = button.closest('[data-uw-buy-form]');
    if (!form) return;
    var label = soldOut
      ? form.getAttribute('data-uw-label-soldout')
      : form.getAttribute('data-uw-label-add');
    if (label) button.textContent = label;
  }

  function apply(root, variant) {
    var input = root.querySelector('[data-uw-variant-input]');
    var button = root.querySelector('[data-uw-buy-button]');
    var priceNow = root.querySelector('[data-uw-price-now]');
    var priceWas = root.querySelector('[data-uw-price-was]');
    var badge = root.querySelector('.uw-product-card__badge');
    var badgeLabel = root.querySelector('[data-uw-badge-label]');

    if (!variant) {
      if (button) {
        button.disabled = true;
        setButtonLabel(button, true);
      }
      return;
    }

    if (input) input.value = variant.id;
    if (button) {
      button.disabled = !variant.available;
      setButtonLabel(button, !variant.available);
    }
    if (priceNow) priceNow.textContent = variant.price;

    if (priceWas) {
      if (variant.compare_at) {
        priceWas.textContent = variant.compare_at;
        priceWas.hidden = false;
      } else {
        priceWas.hidden = true;
      }
    }

    if (badge) {
      if (!variant.available) {
        badge.hidden = false;
        badge.classList.remove('uw-product-card__badge--sale');
        badge.classList.add('uw-product-card__badge--soldout');
        if (badgeLabel) badgeLabel.textContent = badge.getAttribute('data-uw-label-soldout') || badgeLabel.textContent;
      } else if (variant.compare_at) {
        badge.hidden = false;
        badge.classList.remove('uw-product-card__badge--soldout');
        badge.classList.add('uw-product-card__badge--sale');
        if (badgeLabel) badgeLabel.textContent = badge.getAttribute('data-uw-label-sale') || badgeLabel.textContent;
      } else {
        badge.hidden = true;
      }
    }
  }

  function bind(root) {
    if (root.__uwProductBound) return;
    root.__uwProductBound = true;
    var variants = parseVariants(root);
    if (!variants.length) return;
    root.addEventListener('change', function (event) {
      if (!event.target.hasAttribute || !event.target.hasAttribute('data-uw-option-index')) return;
      apply(root, findVariant(variants, chosenValues(root)));
    });
  }

  function gallery(root) {
    root.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var thumb = event.target.closest('[data-uw-thumb]');
      if (!thumb) return;
      event.preventDefault();
      var main = root.querySelector('[data-uw-main-image]');
      if (!main) return;
      main.src = thumb.getAttribute('data-uw-thumb');
      var alt = thumb.getAttribute('data-uw-thumb-alt');
      if (alt !== null) main.alt = alt;
      Array.prototype.forEach.call(root.querySelectorAll('[data-uw-thumb]'), function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-uw-product]'), function (root) {
      bind(root);
      gallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
